import React, { useEffect, useRef } from "react";

const ZoneDropdown = ({
  fleets = [],
  selectedFleet,
  onSelect,
  show,
  toggle,
  dropdownRef,
  AdditionalWrapperClass,
  AdditionalChildClass,
  WrapperClass,
  childClass,
  "data-testid": dataTestId = "zone-dropdown",
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const menuEl = menuRef.current;
    if (!menuEl) return;

    const handleWheel = (e) => {
      e.preventDefault();
      const scrollSpeed = 0.3; // Lower = slower
      menuEl.scrollTop += e.deltaY * scrollSpeed;
    };

    menuEl.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      menuEl.removeEventListener("wheel", handleWheel);
    };
  }, [show]); // Re-attach when dropdown opens

  return (
    <div className={`unitSelect relative flex ${WrapperClass}`} data-testid={dataTestId}>
      <div
        className={`flex items-center gap-2 relative ${AdditionalWrapperClass}`}
        ref={dropdownRef}
        onClick={toggle}
        data-testid={`${dataTestId}-trigger`}
      >
        <div
          className={`text-[#000000DE] dark:text-white cursor-pointer text-sm lg:text-base leading-5 font-medium tracking-[0.024px] block truncate w-full ${
            childClass ? "" : "shrink-0 basis-24"
          }`}
          title={selectedFleet?.name}
        >
          {selectedFleet?.name}
        </div>
        <div className="cursor-pointer shrink-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M19 9L12 15L5 9"
              stroke="black"
              strokeOpacity="0.87"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="dark:stroke-white"
            />
          </svg>
        </div>
        {show && (
          <div
            ref={menuRef} // 👈 Attach the scroll speed control here
            data-testid={`${dataTestId}-menu`}
            className={`dropdownMenuHolder absolute top-full sm:left-auto left-0 right-0 shadow-appShadow dark:shadow-darkThemeDropdownMenuShadow rounded-md z-50 overflow-y-auto ${
              AdditionalChildClass
                ? "w-full mt-[8px] max-h-28"
                : "w-48 min-w-40 mt-[26px] max-h-56"
            }`}
          >
            <ul className="bg-white dark:bg-darkThemeDropdownBg rounded-lg w-full">
              {fleets.map((fleet, index) => (
                <li
                  key={index}
                  data-testid={`${dataTestId}-option-${fleet.unid}`}
                  onClick={() => onSelect(fleet)}
                  className={`px-3 py-2.5 text-dark-grey dark:text-white text-xs text-left leading-4 lg:text-sm lg:leading-5 font-normal tracking-[-0.408px] border-b border-grey dark:border-darkThemeBorder flex justify-between items-center gap-2 cursor-pointer
                    ${
                      fleet?.name === selectedFleet?.name
                        ? "bg-[#FFF1C6] dark:bg-darkThemeDropdownItemBg"
                        : ""
                    }
                    ${index === fleets.length - 1 ? "border-b-0" : ""}`}
                >
                  <span className="basis-10/12 truncate" title={fleet.name}>{fleet.name}</span>
                  {fleet.name === selectedFleet?.name && (
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M8.49215 15C8.24102 15 8.00244 14.8995 7.82665 14.7238L4.27311 11.1702C3.90896 10.8061 3.90896 10.2033 4.27311 9.8392C4.63725 9.47506 5.23997 9.47506 5.60412 9.8392L8.49215 12.7272L14.9463 6.27311C15.3104 5.90896 15.9132 5.90896 16.2773 6.27311C16.6414 6.63725 16.6414 7.23997 16.2773 7.60412L9.15766 14.7238C8.98186 14.8995 8.74329 15 8.49215 15Z"
                          fill="#FF8C65"
                        />
                      </svg>
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ZoneDropdown;
